import type { UpsellComponentsConfig, UpsellTemplateSchema } from '../@types/upsell-types'
import type { OneTimeProduct } from '@/composables/useProducts'
import { mergeDeep } from '@/helpers/utils'
import personalPlanIcon from '@/assets/upsell/summary-list/personal-plan.svg'
import mealWorkoutPlanIcon from '@/assets/upsell/summary-list/meal-workout-plan.svg'
import balanceAndFlexibilityIcon from '@/assets/upsell/summary-list/balance_and_flexibility.svg'
import painFreeWalkingGuideIcon from '@/assets/upsell/summary-list/pain_free_walking_guide.svg'
import easeStressIcon from '@/assets/upsell/summary-list/ease_stress.svg'

export default (schema: UpsellTemplateSchema<OneTimeProduct>): UpsellTemplateSchema<OneTimeProduct> =>
	mergeDeep(
		{ ...schema },
		{
			components: {
				UpsellTitle: ({ ctx, $t }): UpsellComponentsConfig['UpsellTitle'] => {
					const targetWeightHtml = `<span class="upsell-title__weight">${ctx.localizedUserTargetWeight}</span>`
					const simplifyJourney = $t('pages.workbooks_bundle.upsell_title_simplify_journey', {
						target_weight: targetWeightHtml,
					})
					const simplifyJourneyHtml = `<span class="upsell-title__highlight_green">${simplifyJourney}</span>`

					return {
						title: $t('pages.workbooks_bundle.upsell_title_essential_guides', {
							simplify_journey: simplifyJourneyHtml,
						}),
						alignment: 'center',
					}
				},
				UpsellBundleList: ({ $t }): UpsellComponentsConfig['UpsellBundleList'] => ({
					list: [
						{
							text: $t('pages.workbooks_bundle.upsell_personal_plan'),
							icon: personalPlanIcon,
							disabled: true,
						},
						{
							text: $t('pages.workbooks_bundle.upsell_steady_energy_meal_plan'),
							icon: mealWorkoutPlanIcon,
							outlined: true,
							active: true,
						},
						{
							text: $t('pages.workbooks_bundle.upsell_balance_flexibility_daily_life'),
							icon: balanceAndFlexibilityIcon,
						},
						{
							text: $t('pages.workbooks_bundle.upsell_pain_free_walking_guide'),
							icon: painFreeWalkingGuideIcon,
						},
						{
							text: $t('pages.workbooks_bundle.upsell_ease_stress_body_tension'),
							icon: easeStressIcon,
						},
					],
				}),
			},
		},
	)
